import { createFileRoute } from '@tanstack/react-router'
import { resolveLegacyOrganizationsPath } from '@/lib/legacy-routes'
import { redirectFromLegacyPath } from '@/lib/legacy-redirect'

/**
 * A bare `/organizations`, with nothing after it.
 *
 * Its own route rather than a case of the splat beside it: a splat needs
 * something to match, and this URL was the old app's own root redirect — the
 * single most likely one to still be sitting in a bookmark bar.
 */
export const Route = createFileRoute('/organizations/')({
  loader: ({ context: { queryClient } }) =>
    redirectFromLegacyPath(queryClient, resolveLegacyOrganizationsPath([])),
})
